import React from 'react'
import {
  ProgressBar,
  // ChunkProgressBar,
} from '@progress/kendo-react-progressbars'
import { DataService_Models_SurveyProgressBarType } from '../../../api'

interface ProgressBarProps {
  type: string
  totalQuestions: number
  progressBarCount: number
  isSurveyComplete: boolean
}

export default function Progressbar({
  type,
  totalQuestions,
  progressBarCount,
  isSurveyComplete,
}: ProgressBarProps) {
  if (type === DataService_Models_SurveyProgressBarType.NONE) {
    return null
  } else if (type === DataService_Models_SurveyProgressBarType.PROGRESS_STEP) {
    return (
      <div className="theme-progress-bar">
        <ProgressBar
          ariaLabel={`${progressBarCount} of total ${totalQuestions} questions`}
          min={0}
          max={totalQuestions}
          value={isSurveyComplete ? totalQuestions : progressBarCount - 1}
          data-testid="progress-bar"
          labelVisible={true}
          label={(props) => {
            return <strong title={props.value ? (props.value! + '/' + totalQuestions) : '0'}>{props.value ? (props.value! + '/' + totalQuestions) : '0'}</strong>
          }}
        />
      </div>
    )
  } else {
    return (
      <div className="theme-progress-bar">
        <ProgressBar
          ariaLabel={progressBarCount ? `${Math.floor((progressBarCount / totalQuestions) * 100)}%` : `0%`}
          min={0}
          max={totalQuestions}
          value={isSurveyComplete ? totalQuestions : progressBarCount - 1}
          data-testid="progress-bar"
          labelVisible={true}
          label={(props) => {
            return <strong title='progressbar'>{props.value ? Math.floor((props.value! / totalQuestions) * 100) : '0'}%</strong>
          }}


        />
      </div>
    )
  }
}
